import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import MultiSelectPillList from '../MultiSelectPillList'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * optional custom on change handler.
   */
  onChange: PropTypes.func,
  /**
   * When true, show validation errors even if the field was not blurred yet.
   */
  showErrorWhenInvalid: PropTypes.bool,
}

/**
 * Connects the MultiSelectPillList with Formik.
 */
function FormikMultiSelect(props) {
  const { id, onChange = null, showErrorWhenInvalid = false } = props ?? {}

  return (
    <Field name={id}>
      {({ field, meta, form }) => (
        <MultiSelectPillList
          {...props}
          id={id}
          name={id}
          onChange={(value) => {
            if (onChange) {
              onChange(value, form)
            } else {
              form.setFieldValue(id, value)
            }
          }}
          values={field.value}
          errors={(showErrorWhenInvalid || meta.touched) && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikMultiSelect.propTypes = propTypes

export default FormikMultiSelect
